import { api } from './api';

export interface Lead {
  id: number;
  tenantId: number;
  nombre: string;
  email?: string;
  telefono?: string;
  empresa?: string;
  cargo?: string;
  direccion?: string;
  origen: string;
  estado: 'nuevo' | 'contactado' | 'calificado' | 'descalificado' | 'convertido';
  probabilidad: number;
  valorEstimado: number;
  fechaCierreEstimada?: string;
  usuarioAsignadoId?: number;
  clienteId?: number;
  notas?: string;
  usuarioAsignado?: {
    id: number;
    name: string;
    email: string;
  };
  cliente?: {
    id: number;
    nombre: string;
    email?: string;
  };
  createdAt?: string;
  updatedAt?: string;
}

export interface LeadCreate {
  nombre: string;
  email?: string;
  telefono?: string;
  empresa?: string;
  cargo?: string;
  direccion?: string;
  origen?: string;
  probabilidad?: number;
  valorEstimado?: number;
  fechaCierreEstimada?: string;
  usuarioAsignadoId?: number;
  notas?: string;
}

export interface LeadUpdate {
  nombre?: string;
  email?: string;
  telefono?: string;
  empresa?: string;
  cargo?: string;
  direccion?: string;
  origen?: string;
  estado?: 'nuevo' | 'contactado' | 'calificado' | 'descalificado' | 'convertido';
  probabilidad?: number;
  valorEstimado?: number;
  fechaCierreEstimada?: string;
  usuarioAsignadoId?: number;
  clienteId?: number;
  notas?: string;
}

export interface PaginatedResponse<T> {
  data: {
    [key: string]: T[];
    pagination: {
      total: number;
      page: number;
      limit: number;
      totalPages: number;
    };
  };
}

export const leadService = {
  getAll: async (
    page = 1,
    limit = 20,
    search?: string,
    estado?: string,
    usuarioAsignadoId?: number
  ): Promise<PaginatedResponse<Lead>> => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    });
    if (search) params.append('search', search);
    if (estado) params.append('estado', estado);
    if (usuarioAsignadoId) params.append('usuarioAsignadoId', usuarioAsignadoId.toString());
    
    const response = await api.get<PaginatedResponse<Lead>>(`/crm/leads?${params}`);
    return response.data;
  },

  getById: async (id: number): Promise<{ data: { lead: Lead; actividades: any[] } }> => {
    const response = await api.get<{ data: { lead: Lead; actividades: any[] } }>(`/crm/leads/${id}`);
    return response.data;
  },

  create: async (data: LeadCreate): Promise<{ data: { lead: Lead } }> => {
    const response = await api.post<{ data: { lead: Lead } }>('/crm/leads', data);
    return response.data;
  },

  update: async (id: number, data: LeadUpdate): Promise<{ data: { lead: Lead } }> => {
    const response = await api.put<{ data: { lead: Lead } }>(`/crm/leads/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<{ message: string }> => {
    const response = await api.delete<{ message: string }>(`/crm/leads/${id}`);
    return response.data;
  },

  convertToCliente: async (id: number): Promise<{ data: { lead: Lead; cliente: any } }> => {
    const response = await api.post<{ data: { lead: Lead; cliente: any } }>(`/crm/leads/${id}/convertir-cliente`);
    return response.data;
  }
};
